import { render, staticRenderFns } from "./CommunicationHistory.vue?vue&type=template&id=ee5541f6"
import script from "./CommunicationHistory.vue?vue&type=script&lang=js"
export * from "./CommunicationHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports